


















































import { Component } from "vue-property-decorator";
import { EventWidgetComponent } from "../EventWidget";
import MagicValidator from "../../../magic/MagicValidator.vue";
import { isObject } from "@szgc/plt-core-v2";

@Component({
  name: "FloatInputWidget",
  components: { MagicValidator }
})
export default class FloatInputWidget
  extends EventWidgetComponent
  implements App.PuttedWidgetComponent
{
  setValue(value: string) {
    this.value = value;
    this.operateHandler();
  }

  changeHandler(value: string) {
    this.operateHandler();
    this.handleEvent(value);
  }

  mounted() {
    if (this.status === "mine") {
      this.value =
        this.widget.ext === null
          ? isObject(this.defaultValue)
            ? this.defaultValue.value
            : this.defaultValue
          : this.widget.value;
    }
  }
}
